import dayjs, { type Dayjs } from 'dayjs';
import type { QualityRange } from '@/features/quality/hooks';

type DatePickerState = {
  hasCustomDates: boolean;
  startDay: string | null;
  endDay: string | null;
};

export const resolveExecutionRunsToolbarQuickFilter = (
  range: QualityRange,
): '7d' | '14d' | '30d' | 'latest' => {
  return range === 'all' ? '30d' : range;
};

export const resolveExecutionRunsToolbarDates = (
  datePicker: DatePickerState,
): { fromDate: Dayjs | null; toDate: Dayjs | null } => {
  if (!datePicker.hasCustomDates) {
    return { fromDate: null, toDate: null };
  }
  return {
    fromDate: datePicker.startDay ? dayjs(datePicker.startDay) : null,
    toDate: datePicker.endDay ? dayjs(datePicker.endDay) : null,
  };
};
